import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './redux/configureStore';
import App from './containers/app';
import registerServiceWorker from './registerServiceWorker';
import AppAccessToken from './api/appAccessToken';

// get access token as query param and store it for api use
const urlParams = new URLSearchParams(window.location.search);
const accessToken = urlParams.get('access_token');
if (accessToken) {
  AppAccessToken.storeAccessToken(accessToken);
} else {
  AppAccessToken.storeAccessToken(null);
}
  
const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js